define('views/content/reseller_licenses',['require','views/base/list_page_view','views/components/reseller_product/reseller_products','collections/reseller_products','views/components/purchase_information/purchase_information','text!templates/content/reseller_licenses.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var ResellerProductsView = require('views/components/reseller_product/reseller_products');
    var ResellerProductsCollection = require('collections/reseller_products');

    var PurchaseInformationView = require('views/components/purchase_information/purchase_information');

    var temp = require("text!templates/content/reseller_licenses.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-licenses-page',
        titleKey: 'licenses',

        setCollection: function () {
            this.collection = new ResellerProductsCollection();
        },

        regions: function(){
            return {
                ListContainer: ".main-list-container",
                PurchaseInformationContainer: ".purchase-information-container"
            };
        },

        onRender: function() {
            this.ListContainer.show(new ResellerProductsView({
                collection: this.collection
            }));

            this.PurchaseInformationContainer.show(new PurchaseInformationView());

        }

    });
});
